import { gql } from "@apollo/client"
import { SetPrimaryPaymentMethodInput, SetPrimaryPaymentMethodPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const QUERY = gql`
  mutation SetPrimaryPaymentMethod($paymentMethodId: ID!) {
    setPrimaryPaymentMethod(input: { paymentMethodId: $paymentMethodId }) {
      paymentMethod {
        id
      }
      errors
    }
  }
`

export const useSetPrimaryPaymentMethod = (
  options: InjectedOptions<
    { setPrimaryPaymentMethod: SetPrimaryPaymentMethodPayload },
    SetPrimaryPaymentMethodInput
  >,
) => useMutation(QUERY, options)
